import { t } from 'i18next';

// import ProductAddCard from 'components/desktop/Ingredient/IngredientProducts/ProductAddCard/ProductAddCard';
import ProductCardSlider from 'components/desktop/Ingredient/IngredientProducts/ProductCardSlider/ProductCardSlider';
import ProductDetailCard from 'components/desktop/Ingredient/IngredientProducts/ProductDetailCard/ProductDetailCard';
import FoldableCard from 'components/desktop/_general/Card/FoldableCard/FoldableCard';
import { SliderCard } from 'components/desktop/_general/CardSlider/CardSlider';
import LoadingSpinner from 'components/desktop/_general/Loading/LoadingSpinner';
import { useReaction } from 'hooks/useReaction';
import * as IngredientProduct from 'types/Product/IngredientProduct';
import * as Criterion from 'types/Recipe/Detail/Erp/Criterion';
import * as Product from 'types/Recipe/Detail/Erp/Product';
import * as ProductList from 'types/Recipe/Detail/Erp/ProductList';

interface IProps {
	disabled: boolean;
	products: IngredientProduct.Type[];
	setProducts: (products: IngredientProduct.Type[]) => void;
	ingredientId: string;
}

const IngredientProducts = (props: IProps) => {
	const [productMatches, isLoaded] = useReaction<Product.Type[], string>(
		[],
		async (ingredientId: string) =>
			await ProductList.getFromApi({
				...Criterion.create([ingredientId]),
				type: 'id',
				pageSize: 10,
				pageIndex: 0,
			}),
		props.ingredientId
	);

	const handleDelete = (_e: any, index: number) => {
		const productsCpy = [...props.products];
		productsCpy.splice(index, 1);
		props.setProducts(productsCpy);
	};

	const getCards = (products: IngredientProduct.Type[]): SliderCard[] => {
		const cards: SliderCard[] = [];

		(products ?? productMatches).map((x, index) => {
			cards.push({
				content: (
					<ProductDetailCard handleDelete={handleDelete} index={index} product={x} />
				),
			});
		});

		return cards;
	};

	const getContent = (): JSX.Element => {
		if (!isLoaded) return <LoadingSpinner />;
		return <ProductCardSlider cards={getCards(props.products)} />;
	};

	return (
		<div className="margin-top-25">
			<FoldableCard
				defaultOpen={true}
				dataComponentType="ingredient-products-card"
				title={t('ingredient:PRODUCTS')}
				ai={true}
				content={getContent()}
				disabled={props.disabled}
			/>
		</div>
	);
};

export default IngredientProducts;
